'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep1SelectReceiverFormComponent = exports.parcelAddStep1SelectReceiverFormComponent = {
    template: require('./parcel-add-step1-select-receiver-form.html'),
    controllerAs: 'vm',
    bindings: {
        receiver: '<',
        selectReceiver: '&',
        validateReceiver: '&',
        cancel: '&'
    },
    controller: ["gettextCatalog", function parcelAddStep1SelectReceiverFormController(gettextCatalog) {
        'ngInject';

        var vm = this;

        vm.orderTypeId;
        vm.licenseNumber;
        vm.error;
        vm.errorNotFound;

        vm.$onInit = init;
        vm.submitStep1Form = submitStep1Form;
        vm.onCancel = onCancel;

        function init() {
            resetStep1Form();
        }

        function resetStep1Form() {
            vm.orderTypeId = 1;
            vm.licenseNumber = vm.receiver ? vm.receiver.licenseNumber : null;
            vm.error = null;
            vm.errorNotFound = false;
        }

        function submitStep1Form() {
            if (!vm.licenseNumber) {
                vm.error = gettextCatalog.getString('parcel.enterLicenseNumberShort');
                vm.errorNotFound = false;
                return;
            } else if (isNaN(vm.licenseNumber)) {
                vm.errorNotFound = true;
                vm.error = null;
            } else {
                vm.validateReceiver({ $event: { licenseNumber: vm.licenseNumber } }).then(function (response) {
                    vm.error = null;
                    vm.errorNotFound = false;
                    vm.selectReceiver({ $event: response });
                }, function () {
                    vm.errorNotFound = true;
                    vm.error = null;
                });
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-add-step1-select-receiver-form.js
// module id = 870
// module chunks = 0